import {Card, Col, Row} from 'react-bootstrap';
import './style.css';
import t from '../../../data/translations';

const OutletSearch = ({
  onSearch, onClear, onChange, searchValue, placeholder = t('outlet.search.placeholder')
}) => {
  const doSearch = (e) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };


  return (
    <Row>
      <Col md={12}>
        <Card className="mg-tb-20">
          <Card.Body>
            <div className="fluid">
              <input
                className="form-control"
                onChange={onChange}
                onKeyPress={doSearch}
                placeholder={placeholder}
                value={searchValue}
              />
            </div>
            <div className="fluid text-right search-button">
              <button className="btn red-ghost-btn mg-10" onClick={onSearch}>
                Search
              </button>
              <button className="btn red-ghost-btn mg-10" onClick={onClear}>
                Clear Search
              </button>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default OutletSearch;
